import { EventDispatcher } from "../../../utils/EventDispatcher";
import { Events } from "../../../utils/Events";

export class RouletteModel {

    private static MAX_DELTA_ANGLE = 5;
    private static INCREASE_DELTA_ANGLE = 0.1;

    public a: number;
    public spinning: boolean;
    public f:number;
    public deltaAngle: number;
    public slowDown: boolean;
    
    private eventDispatcher: EventDispatcher;
    private framesToSlowDown: number;

    private slowDownAngularSpeed: number;

    constructor() {
        
        this.a = 0;
        this.spinning = false;
        this.deltaAngle = 0;
        this.slowDown = false;
        this.f = 0;

        this.framesToSlowDown = null;

        this.eventDispatcher = new EventDispatcher();
    }

    public update(): void {

        this.f ++;

        if (this.spinning) {

            this.a += this.deltaAngle 

            if (this.slowDown && this.f > this.framesToSlowDown) { 

                this.deltaAngle -= this.slowDownAngularSpeed;

                if (this.deltaAngle <= .1) {

                    this.spinning = false;

                    this.eventDispatcher.dispatchEvent(new Events(Events.STOP_SPINNING, []));
                }

            } else {

                this.deltaAngle = this.deltaAngle < RouletteModel.MAX_DELTA_ANGLE ? this.deltaAngle + RouletteModel.INCREASE_DELTA_ANGLE : RouletteModel.MAX_DELTA_ANGLE;
            }
        }
    }

    public addEventListener(type: string, listenerFunction: Function, scope: any): void {

        this.eventDispatcher.addEventListener(type, listenerFunction, scope);
    }

    public removeEventListener(type: string, listenerFunction: Function): void {

        this.eventDispatcher.removeEventListener(type, listenerFunction);
    }

    public spin(): void {
        
        this.spinning = true;
    }

    public stop(slowDownAngularSpeed: number): void {
        
        this.slowDown = true;
        this.slowDownAngularSpeed = slowDownAngularSpeed;
        this.framesToSlowDown = this.f;
    }

    public getAngle(): number {

        return this.a - 360 * Math.floor(this.a / 360);
    }
}
